<template>
    <div class="core-product">
        <div class="title">
            <div class="title-more">COER PRODUCT</div>
            <div class="title-text"><span>核心</span><span>产品</span></div>

            <div class="line"></div>
        </div>
        <div class="content">
            <div class="content-item" @click="gotoDetail(item.path)" v-for="(item, index) in productList" :key="index">
                <img v-lazy="item.url" alt="">
                <div class="content-item-text">
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import product1 from '@/assets/images/index/product1.png';
import product2 from '@/assets/images/index/product2.png';
import product3 from '@/assets/images/index/product3.png';
import product4 from '@/assets/images/index/product4.png';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
const store = useStore();
const router = useRouter();
const productList = ref([
    {
        title: "设备数字看板及报表",
        url: product1,
        path: "/product-center/EDK"
    },
    {
        title: "设备数字孪生平台",
        url: product2,
        path: "/product-center/EDT"
    }, {
        title: "全球设备数字资产管理平台",
        url: product3,
        path: "/product-center/GEDAM"
    },
    {
        title: "AI应用服务平台",
        url: product4,
        path: '/product-center/AI-serve'

    }
])
const gotoDetail = (path) => {
    store.commit('setNavIndex', 1);
    router.push({
        path: path
    })
}
</script>

<style lang="less" scoped>
.core-product {
    margin-top: 6.25rem;
    width: 100%;
    height: 47.875rem;
    background-image: url('@/assets/images/index/coreProcuctBg.png');
    background-size: 100% 100%;
    padding-left: 15.3125rem;
    padding-right: 15.3125rem;
    padding-top: 6.875rem;
    display: flex;
    flex-direction: column;
    // @/assets/images/index/productRigt.png
}

.title {
    font-size: 3.125rem;
    font-weight: bold;
    position: relative;
    height: 8.75rem;
    width: 100%;

    ;


    .title-text {
        position: absolute;
        top: .375rem;
        left: 0;
        color: #fff;

        span {
            &:nth-child(2) {
                color: #5DBE21;
            }
        }
    }

    .title-more {
        font-size: 6.25rem;
        -webkit-text-stroke: 2px #999;
        opacity: 0.4;
        color: transparent; //字体颜色设置为透明
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
    }

    .line {
        width: 100%;
        height: .125rem;
        background: #fff;
        position: absolute;
        bottom: 0;
        opacity: 0.2;
    }
}

.content {
    flex: 1;
    padding-top: 3.125rem;
    display: flex;
    justify-content: space-between;

    .content-item {
        width: 20.9375rem;
        height: 20rem;
        position: relative;
        border-radius: .625rem;
        transition: all 0.5s;
        border-radius: 1.25rem;

        &:hover {
            transform: scale(1.05);
        }

        .content-item-text {
            width: 100%;
            height: 4.375rem;
            background-color: rgba(255, 255, 255, .2);

            position: absolute;
            bottom: 0px;
            left: 0;
            border-radius: 0 0 1.25rem 1.25rem;
            backdrop-filter: blur(.5rem);
            line-height: 4.375rem;
            font-size: 1.5rem;
            color: #fff;
        }

        img {
            width: 100%;
            height: 100%;
            ;
        }
    }
}
</style>